import React from 'react';
import { ArtifactType, Solicitacao } from '@/models/Solicitacao';
import { usePrescricaoLivreContext } from '@/features/prescricao-livre/providers/PrescricaoLivreProvider';
import {
  defaultItemStatus,
  itemStateToApi,
} from '@/features/prescricao-livre/helpers/parsers';
import { useSolicitacoesContext } from '@/features/solicitacoes/providers/SolicitacoesProvider.index';

interface UseSolicitacoesConsolidadas {
  solicitacoes: Solicitacao[];
  solicitacoesPorTipo: (tipoArtefato: ArtifactType) => Solicitacao[];
}

export function useSolicitacoesConsolidadas(): UseSolicitacoesConsolidadas {
  const { items: prescricaoLivre } = usePrescricaoLivreContext();
  const { solicitados: itensComplementares } = useSolicitacoesContext();

  const solicitacoes = React.useMemo(() => {
    const items: Solicitacao[] = [...itensComplementares];

    if (prescricaoLivre.length) {
      items.push(
        ...prescricaoLivre
          .filter(
            ({
              itemState: {
                isAdding = false,
                isCanceling = false,
                isEditing = false,
                isSubmitting = false,
              } = defaultItemStatus,
            }) => !(isAdding || isCanceling || isEditing || isSubmitting),
          )
          .map<Solicitacao>(item => itemStateToApi(item)),
      );
    }

    return items;
  }, [itensComplementares, prescricaoLivre]);

  const solicitacoesPorTipo = React.useCallback(
    (tipoArtefato: ArtifactType) => {
      return solicitacoes.filter(
        solicitacao => solicitacao.tipo === tipoArtefato,
      );
    },
    [solicitacoes],
  );

  return {
    solicitacoes,
    solicitacoesPorTipo,
  };
}
